import request from 'superagent'
import { resolve } from 'url'
import { compose, startsWith } from 'ramda'
import { parse } from 'url'
import { getCsrf } from 'util/session'
import config from 'config'

import { getNetworkSubdomain } from 'src/lib/middleware'

// utility fn to enable similar shape requests to API from
// frontend and backend, req is http request from getInitialProps
export default function isomorphicRequest(req, ctx = {}) {
  if (!req && typeof window != 'object') {
    throw new Error('req object is required for server-side requests')
  }

  const addCookies = r => {
    r.redirects(0)

    // jest tests supply a global TEST_ID
    // this allows for data isolation per test
    if (global.TEST_ID) {
      r.query({ 'test-id': global.TEST_ID })
    }
    if (global.TEST_SESSION) {
      r.set('cookie', `${config.NEXT_PUBLIC_COOKIE_NAME}=${global.TEST_SESSION}`)
    }

    if (config.NEXT_PUBLIC_DD_VERSION) {
      r.set('x-yellowdig-version', config.NEXT_PUBLIC_DD_VERSION)
    }

    if (ctx && ctx.asPath) {
      r.set('x-yellowdig-url', ctx.asPath)
    }

    if (ctx && ctx.pathname) {
      r.set('x-yellowdig-path', ctx.pathname)
    }

    if (ctx.req && ctx.req.headers['user-agent']) {
      r.set('x-yellowdig-user-agent', ctx.req.headers['user-agent'])
    }

    if (!req) {
      const subdomain = getNetworkSubdomain({})
      r.set('x-yellowdig-url', window.location.pathname)
      r.set('x-yellowdig-network-name', subdomain)
    }

    if (req && ctx.req && ctx.res) {
      const subdomain = getNetworkSubdomain(ctx)
      r.set('x-yellowdig-network-name', subdomain)
    }

    const csrfValue = getCsrf(req)

    if (csrfValue) {
      r.set('x-yellowdig-csrf-token', getCsrf(req))
    }

    if (req) {
      if (req.headers.cookie) {
        r.set('cookie', req.headers.cookie)
      }
      return r
    }

    if (!req) {
      const ua = window.navigator && window.navigator.userAgent
      r.set('x-yellowdig-user-agent', ua)
      return r.withCredentials()
    }
  }

  const windowLocation = _ => {
    if (typeof window === 'object') {
      return window.location.href
    }
  }

  const addQueryParams = r => {
    const url = req ? req.url : windowLocation()
    const parsed = parse(url, true)
    const { asof, batch } = parsed.query
    if (asof || batch) {
      r.query({ asof, batch })
    }
    return r
  }

  const toUrl = path => {
    if (startsWith('/', path)) {
      return resolve(config.NEXT_PUBLIC_API_URL, path)
    }
    return path
  }

  const composed = compose(addQueryParams, addCookies)

  return {
    get: path => composed(request.get(toUrl(path))),
    post: path => composed(request.post(toUrl(path)))
  }
}
